import { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";

const deepCompareEquals = (a, b) => {
  return isEqual(a, b);
};

const useDeepCompareMemoize = (value) => {
  const ref = useRef();

  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
};

const useDeepCompareEffect = (callback, dependencies) => {
  const memoizedDeps = useDeepCompareMemoize(dependencies);

  useEffect(() => {
    return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callback, memoizedDeps]);
};

export default useDeepCompareEffect;
